<template>
    <div class="prospect_content">
        <div class="prospect_img">
            img
        </div>
        <div class="prospect_content_warp">
            <div class="prospect_text">
                <div class="prospect_label">
                    定位交底
                </div>
                <div class="prospect_label_text">
                    技术交底时明确本工程的特定施工条件、施工组织、具体技术要求和有针对性的关键技术措施，系统掌握工程施工过程全貌和施工的关键部位。<br><br>使参与工程施工操作每一个人，通过技术交底，了解自己所要完成的分部分项工程的具体工作内容，操作方法、施工工艺、质量标准和安全注意事项等，做到施工操作人员任务明确，心中有数达有序地施工、以减少各种质量通病提高施工质量的目的。
                </div>
            </div>
            <div class="prospect_card">
                <div class="prospect_flb">
                    <img class="head-img" src="@/assets/images/user/house/head-img.png" alt="">
                    <div class="info-wrap">
                        <div class="info-con1">签单手：徐达</div>
                        <div class="info-con2">2年工作经验</div>
                        <div class="info-con3">2753单 96.0% 好评</div>
                    </div>
                </div>
                <img class="phone-icon" src="@/assets/images/user/house/phone-icon.png" alt="">
            </div>
            <div class="prospect_text">
                <div class="prospect_label_green">室外机定位及预留要求</div>
                <div class="prospect_item">空间预留：外机的安装预留尺寸符合要求</div>
                <div class="">
                    <div class="prospect_input_model prospect_input_model_center">
                        <div class="prospect_input_model_warp">
                            <div class="prospect_input_title">
                                后部预留尺寸<br>
                                (空气吸入侧）
                            </div>
                            <div class="prospect_input prospect_input_left">
                                <div v-if="arrInput[0].inputValueFiveShow&&arrInput[0].inputValueFive">{{arrInput[0].inputValueFive}}mm</div>
                                <input v-if="arrInput[0].inputValueFiveShow&&!arrInput[0].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[0].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[0].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',0)" @blur="setFocus($event,'blur',0)">
                            </div>
                        </div>
                    </div>
                    <div class="prospect_input_model">
                        <div class="prospect_input_model_warp prospect_input_column">
                            <div class="prospect_input_title">
                                左侧预留尺寸<br>
                                (非接管侧）
                            </div>
                            <div class="prospect_input prospect_input_on">
                                <div v-if="arrInput[1].inputValueFiveShow&&arrInput[1].inputValueFive">{{arrInput[1].inputValueFive}}mm</div>
                                <input v-if="arrInput[1].inputValueFiveShow&&!arrInput[1].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[1].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[1].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',1)" @blur="setFocus($event,'blur',1)">
                            </div>
                        </div>
                        <div class="prospect_model_img">
                            <img src="@/assets/images/pagin/img_three.png" alt="">
                        </div>
                        <div class="prospect_input_model_warp prospect_input_column">
                            <div class="prospect_input_title">
                                右侧预留尺寸<br>
                                (接管侧）
                            </div>
                            <div class="prospect_input prospect_input_on">
                                <div v-if="arrInput[2].inputValueFiveShow&&arrInput[2].inputValueFive">{{arrInput[2].inputValueFive}}mm</div>
                                <input v-if="arrInput[2].inputValueFiveShow&&!arrInput[2].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[2].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[2].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',2)" @blur="setFocus($event,'blur',2)">
                            </div>
                        </div>
                    </div>
                    <div class="prospect_input_model prospect_input_model_center">
                        <div class="prospect_input_model_warp">
                            <div class="prospect_input_title">
                                前部预留尺寸<br>
                                (空气吹出侧）
                            </div>
                            <div class="prospect_input prospect_input_left">
                                <div v-if="arrInput[3].inputValueFiveShow&&arrInput[3].inputValueFive">{{arrInput[3].inputValueFive}}mm</div>
                                <input v-if="arrInput[3].inputValueFiveShow&&!arrInput[3].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[3].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[3].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',3)" @blur="setFocus($event,'blur',3)">
                            </div>
                        </div>
                    </div>
                    <div class="dander">单位：mm</div>
                </div>
                <div class="prospect_item prospect_item_border_bottom prospect_item_border_top">外机基础平整/强度应符合外机安装要求</div>
                <div class="prospect_item prospect_item_border_bottom">外机就位方式：爬楼</div>
                <div class="prospect_item prospect_item_border_bottom">电源预留：规格 220V、线经 5mm、长度 3m</div>
            </div>
            <div class="prospect_text">
                <div class="prospect_label_green">风机盘管定位及预留要求</div>
                <div class="prospect_item">每台风机盘管的安装尺寸，现场或图纸上均已做标注</div>
                <div class="prospect_input_model">
                    <div class="prospect_model_img_two">
                        <img src="@/assets/images/pagin/img_two.png" alt="">
                    </div>
                </div>
                <div class="prospect_item prospect_item_border_bottom">每台风机盘管的吊顶高度预留、深度预留均已交底</div>
                <div class="prospect_item prospect_item_border_bottom">每台风机盘管出风口、回风口、检修口预留尺寸均已交底</div>
                <div class="prospect_item prospect_item_border_bottom">系统供回水管、冷凝水管走向均已交底：</div>
                <div class="prospect_item prospect_item_border_bottom">电源预留：规格220V、线径5mm</div>
                <div class="prospect_item prospect_item_border_bottom">每台风机盘管所需要的电源长度参数已交底</div>
            </div>
            <div class="prospect_text">
                <div class="prospect_label_green">锅炉定位及预留要求</div>
                <div class="prospect_item">壁挂炉安装预留尺寸符合要求</div>
                <div class="prospect_label_content">
                    <div class="prospect_input_model prospect_input_model_center">
                        <div class="prospect_input_model_warp">
                            <div class="prospect_input_title">
                                烟管最高点距顶部
                            </div>
                            <div class="prospect_input prospect_input_left">
                                <div v-if="arrInput[4].inputValueFiveShow&&arrInput[4].inputValueFive">{{arrInput[4].inputValueFive}}mm</div>
                                <input v-if="arrInput[4].inputValueFiveShow&&!arrInput[4].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[4].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[4].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',4)" @blur="setFocus($event,'blur',4)">
                            </div>
                        </div>
                    </div>
                    <div class="prospect_input_model">
                        <div class="prospect_input_model_warp prospect_input_column">
                            <div class="prospect_input_title">
                                左侧尺寸
                            </div>
                            <div class="prospect_input prospect_input_on">
                                <div v-if="arrInput[5].inputValueFiveShow&&arrInput[5].inputValueFive">{{arrInput[5].inputValueFive}}mm</div>
                                <input v-if="arrInput[5].inputValueFiveShow&&!arrInput[5].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[5].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[5].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',5)" @blur="setFocus($event,'blur',5)">
                            </div>
                        </div>
                        <div class="prospect_model_bx">
                            <img src="@/assets/images/pagin/img_one.png" alt="">
                        </div>
                        <div class="prospect_input_model_warp prospect_input_column">
                            <div class="prospect_input_title">
                                右侧尺寸
                            </div>
                            <div class="prospect_input prospect_input_on">
                                <div v-if="arrInput[6].inputValueFiveShow&&arrInput[6].inputValueFive">{{arrInput[6].inputValueFive}}mm</div>
                                <input v-if="arrInput[6].inputValueFiveShow&&!arrInput[6].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[6].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[6].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',6)" @blur="setFocus($event,'blur',6)">
                            </div>
                        </div>
                    </div>
                    <div class="prospect_input_model">
                        <div class="prospect_input_model_warp">
                            <div class="prospect_input_title">
                                正面尺寸
                            </div>
                            <div class="prospect_input prospect_input_left">
                                <div v-if="arrInput[7].inputValueFiveShow&&arrInput[7].inputValueFive">{{arrInput[7].inputValueFive}}mm</div>
                                <input v-if="arrInput[7].inputValueFiveShow&&!arrInput[7].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[7].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[7].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',7)" @blur="setFocus($event,'blur',7)">
                            </div>
                        </div>
                        <div class="prospect_input_model_warp">
                            <div class="prospect_input_title">
                                下部尺寸
                            </div>
                            <div class="prospect_input prospect_input_left">
                                <div v-if="arrInput[8].inputValueFiveShow&&arrInput[8].inputValueFive">{{arrInput[8].inputValueFive}}mm</div>
                                <input v-if="arrInput[8].inputValueFiveShow&&!arrInput[8].inputValueFive" readonly placeholder="输入尺寸">
                                <input :class="[arrInput[8].inputValueFiveShow?'opiten':'']" type="number" v-model="arrInput[8].inputValueFive" pattern="\d*" placeholder="输入尺寸" @focus="setFocus($event,'focus',8)" @blur="setFocus($event,'blur',8)">
                            </div>
                        </div>
                    </div>
                    <div class="dander_left">
                        <div>进出水口高度：120mm</div>
                        <div>电源插座高度：120mm</div>
                    </div>
                </div>
                <div class="prospect_item prospect_item_border_bottom">
                    <div class="prospect_item_left">锅炉要求:</div>
                    <div class="prospect_item_right">
                        <div class="prospect_item_right_content" style="margin-bottom:0;">
                            <div>气源：天然气</div>
                            <div>气表规格：G2.5</div>
                        </div>
                    </div>
                </div>
                <div class="prospect_item prospect_item_border_bottom">冷凝水排水管已标注（冷凝水管&lt;DN 25）</div>
                <div class="prospect_item prospect_item_border_bottom">零冷水锅炉循环水管已标注</div>
                <div class="prospect_item">
                    <div class="prospect_item_left">增加烟管</div>
                    <div class="prospect_item_right">
                        <div class="prospect_item_right_content" v-for="(item,index) in arrYanguan" :key="index">
                            <div>{{item.name}}</div>
                            <div>{{item.num}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 帮助 -->
        <el-help :bShowHelp.sync="bShowHelp"></el-help>
    </div>
</template>

<script>
import elHelp from "@/components/elhelp/index.vue";
export default {
    components: {
        elHelp,
    },
    data() {
        return {
            arrInput: [
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
                { inputValueFive: "", inputValueFiveShow: true },
            ],
            arrYanguan: [
                { name: "加长烟管1米", num: "2根" },
                { name: "加长烟管0.5米", num: "2根" },
                { name: "加长烟管0.3米", num: "2根" },
                { name: "90°弯头", num: "2个" },
                { name: "45°弯头", num: "3个" },
            ],
            bShowHelp: false,
        };
    },
    methods: {
        setFocus(e, type, num) {
            if (type == "focus") {
                this.arrInput[num].inputValueFiveShow = false;
            } else if (type == "blur") {
                this.arrInput[num].inputValueFiveShow = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.opiten {
    position: absolute;
    opacity: 0;
}
.dander {
    margin-top: 26px;
    margin-bottom: 30px;
    font-size: 24px;
    color: #a2a2a2;
    text-align: right;
}
.dander_left {
    margin-top: 26px;
    margin-bottom: 30px;
    font-size: 24px;
    color: #444;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.prospect_content {
    width: 100%;
    min-height: 100vh;
    .prospect_img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 366px;
        background: #ededed;
        color: #222222;
        font-size: $bigSize;
    }
    .prospect_content_warp {
        width: 100%;
        padding: 28px 24px 180px;
        box-sizing: border-box;
        background: $commonBgColor;
        .prospect_text {
            background: #fff;
            padding: 24px 24px 28px 24px;
            box-sizing: border-box;
            margin-bottom: 24px;
            border-radius: $commonRadius;
            .prospect_label {
                color: #313131;
                font-size: $bigSize;
                font-weight: 700;
                display: flex;
                align-items: center;

                &::before {
                    content: "";
                    display: flex;
                    width: 6px;
                    height: 32px;
                    background: $deepGreen;
                    margin-right: 12px;
                }
            }
            .prospect_label_green {
                color: $deepGreen;
                font-size: $bigSize;
                font-weight: 700;
                display: flex;
                align-items: center;

                &::before {
                    content: "";
                    display: flex;
                    width: 6px;
                    height: 32px;
                    background: $deepGreen;
                    margin-right: 12px;
                }
            }
            .prospect_label_content {
                width: 100%;
                padding: 0 20px;
                box-sizing: border-box;
            }
            .prospect_input_model_center {
                justify-content: center !important;
            }
            .prospect_input_model {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .prospect_input_column{
                    flex-direction: column;
                }
                .prospect_input_model_warp {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    // flex-wrap: wrap;
                    .prospect_input_title {
                        color: #444444;
                        font-size: 24px;
                    }
                    .prospect_input {
                        width: 148px;
                        height: 56px;
                        border-radius: $commonRadius;
                        border: 2px solid #dcdcdc;
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        input {
                            text-align: center;
                            color: #444444;
                            width: 100%;
                        }
                    }
                    .prospect_input_on {
                        margin-top: 20px;
                    }
                    .prospect_input_left {
                        margin-left: 20px;
                    }
                }
                .prospect_model_img {
                    width: 332px;
                    height: 252px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .prospect_model_img_two {
                    width: 100%;
                }
                .prospect_model_bx {
                    width: 272px;
                    height: 454px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 100%;
                    }
                }
            }
            .prospect_item {
                // height: 94px;
                padding: 30px 0;
                box-sizing: border-box;
                width: 100%;
                display: flex;
                // align-items: center;
                font-size: 28px;
                &::before {
                    content: "";
                    display: flex;
                    width: 36px;
                    height: 36px;
                    background: url("~@/assets/images/pagin/finish_icon.png")
                        no-repeat center/100% 100%;
                    margin-right: 12px;
                }
                .prospect_item_left {
                    width: 20%;
                }
                .prospect_item_right {
                    width: 70%;
                    .prospect_item_right_content {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        font-size: 28px;
                        padding-left: 20px;
                        box-sizing: border-box;
                        div {
                            width: 50%;
                            text-align: center;
                            &:first-child {
                                text-align: left;
                            }
                            &:last-child {
                                width: 48%;
                            }
                        }
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .prospect_item_border_bottom {
                border-bottom: 2px dashed #f1f1f1;
            }
            .prospect_item_border_top {
                border-top: 2px dashed #f1f1f1;
            }
            .prospect_label_text {
                margin-top: 20px;
                color: #444444;
                font-size: $baseSize;
                text-align: justify;
            }
        }
        .prospect_card {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #fff;
            margin-bottom: 24px;
            border-radius: $commonRadius;
            padding: 28px 24px;
            .prospect_flb {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .head-img {
                    width: 120px;
                    height: 120px;
                    border-radius: 50%;
                }
                .info-wrap {
                    margin-left: 20px;
                    .info-con1 {
                        color: $commonTitle;
                        font-size: $baseSize;
                        font-weight: 700;
                    }
                    .info-con2 {
                        color: #a2a2a2;
                        font-size: $smallSize;
                    }
                    .info-con3 {
                        margin-top: 12px;
                        color: $deepGreen;
                        font-size: $smallSize;
                    }
                }
            }
            .phone-icon {
                width: 120px;
                height: 120px;
                border-radius: 50%;
            }
        }
    }
}
</style>